import {Box, Paper, Skeleton, Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {selectMode, selectProject} from "../../redux/selectors/editor";
import {selectProjects} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {Projects} from "../../redux/types/firebase";

const useStyles = makeStyles(theme => ({
    background: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2200
    },
    content: {
        alignItems: "center",
        justifyContent: "center",
        position: 'fixed',
        display: "flex",
        flexDirection: "column",
        top: theme.spacing(4),
        bottom: theme.spacing(4),
        left: theme.spacing(4),
        right: theme.spacing(4)
    }
}));

interface ILoadingScreen {
    mode: string
    project: string
    projects: Projects
}
function LoadingScreen({mode, project, projects}: ILoadingScreen) {
    const classes = useStyles();
    const name = projects ? projects[project]?.name : project;

    return (
        <Box className={classes.background}>
            <Box className={classes.content}>
                <Paper>
                    <Box p={4}>
                        <Typography variant="h5">Loading Project {name}</Typography>
                        <Skeleton variant="rectangular" height={20} sx={{m:1}}/>
                        <Skeleton variant="rectangular" height={180} sx={{m:1}}/>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    mode: selectMode(store),
    project: selectProject(store),
    projects: selectProjects(store),
});
export default connect(mapStateToProps, {
})(LoadingScreen);
